import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import { cleanSeparators } from './Utils'
import SubMenuItem from './SubMenuItem'

const classNames = require('classnames');

class SubMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isSecondLevel: props.isSecondLevel,
			open: false
		}
	}

	_toggleVisibility = () => {
		this.setState({ open: !this.state.open })
	}

	render() {
		const { item } = this.props;
			
		return (
			<NavDropdown
				title={item.text}
				id={item.text}
				className={classNames({ 'c-dropdown-submenu': this.state.isSecondLevel, open: this.state.open })}
				onMouseEnter={this._toggleVisibility}
				onMouseLeave={this._toggleVisibility} >
				{cleanSeparators(item.childs).map((x, i) => <SubMenuItem item={x} key={i} />)}
			</NavDropdown>
		)
	}
}

export default SubMenu;



// WEBPACK FOOTER //
// ./src/fw/components/menu/SubMenu.js